import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox, Button } from 'Components';
import TestPickListTest from '../TestPickListTest/TestPickListTest';
import './TestPickListPackage.css';

const TestPickListPackage = ({
  checked,
  collapsed,
  onCheck,
  onCollapse,
  onTestCollapse,
  onParameterCheck,
  onParameterCheckAll,
  GroupingCode,
  GroupingCodeType,
  HasParameters,
  Tests,
  isHidden,
  isTestHeaderShown,
  DisplayLabels,
  bin,
  IsReadOnly,
}) => (
  <div className={`test-pick-list-package ${!collapsed ? 'test-pick-list-package-container--expanded' : ''}`}>
    <div className={`test-pick-list-package__head ${!collapsed ? 'test-pick-list--package--expanded' : ''}  ${isHidden ? 'test-pick-list-package__head--hidden' : ''}`}>
      {IsReadOnly ? <div className="test-pick-list-package-no-checkbox" /> : <CheckBox checked={checked} onClick={onCheck} />}
      <Button className="test-pick-list-package__head__collapse" onClick={(!['T', 'M'].includes(GroupingCodeType) || HasParameters) ? onCollapse : null} >
        { (GroupingCodeType === 'M') ?
          <span className="test-pick-list-package__head__collapse__line-1">{GroupingCode}</span>
          :
          <div>
            { DisplayLabels.map(x => <span key={x.line}>{x.Label}</span>) }
          </div>
        }
      </Button>
      {(!['T', 'M'].includes(GroupingCodeType) || HasParameters || (Tests.length > 0 && Tests.some(t => t.Parameters !== undefined && t.Parameters.length > 0))) &&
        <Button className="test-pick-list-package__head__arrow" onClick={onCollapse}>
          <i className="material-icons" style={collapsed ? { transform: 'rotate(180deg)' } : undefined}>arrow_drop_up</i>
        </Button>
      }
    </div>
    { (!collapsed && !isHidden) &&
        Tests.map((Test, t) => (
          <TestPickListTest
            {...Test}
            key={`${bin}-${t}`}
            bin={bin}
            Parameters={Test.Parameters}
            isTestHeaderShown={isTestHeaderShown}
            onParameterCheck={m => onParameterCheck(t, m)}
            onParameterCheckAll={() => onParameterCheckAll(t)}
            onTestCollapse={() => onTestCollapse(t)}
            IsReadOnly={IsReadOnly}
          />))
    }
  </div>
);

TestPickListPackage.propTypes = {
  checked: PropTypes.bool,
  collapsed: PropTypes.bool,
  onTestCollapse: PropTypes.func,
  GroupingCode: PropTypes.string,
  GroupingCodeType: PropTypes.string,
  onCheck: PropTypes.func,
  onParameterCheck: PropTypes.func,
  onParameterCheckAll: PropTypes.func,
  onCollapse: PropTypes.func,
  DisplayLabels: PropTypes.arrayOf(PropTypes.shape({})),
  Tests: PropTypes.arrayOf(PropTypes.shape({})),
  isHidden: PropTypes.bool,
  isTestHeaderShown: PropTypes.bool,
  bin: PropTypes.string,
  IsReadOnly: PropTypes.bool,
};

TestPickListPackage.defaultProps = {
  Tests: [],
  isHidden: false,
  isTestHeaderShown: true,
  DisplayLabels: [],
};

export default TestPickListPackage;



// WEBPACK FOOTER //
// ./src/components/TestPickList/TestPickListPackage/TestPickListPackage.jsx